import type { JSX } from 'react'

import { AssetThumbnail } from '~publish/components/AssetThumbnail'
import { MediaCombinedPreview } from '~publish/components/MediaCombinedPreview'

import styles from './CollapsedImagesPreview.module.css'

export type CollapsedImagesPreviewImage = Readonly<{
  url: string
  altText?: string | null
}>

export function CollapsedImagesPreview({
  images,
}: {
  images: readonly CollapsedImagesPreviewImage[]
}): JSX.Element {
  return (
    <MediaCombinedPreview className={styles.mediaPreviewGrid}>
      {images.map((image) => (
        <AssetThumbnail.Image
          key={image.url}
          src={image.url}
          alt={image.altText || ''}
        />
      ))}
    </MediaCombinedPreview>
  )
}
